import { observable } from 'mobx';
import { useMount, useRequest } from 'ahooks';
import { noop } from '@src/utils/common-util';
import Service from '@src/business-components/video-modal/service';

class VideoModalStore {
  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  @observable showStatus = false;

  @observable videoUrl = '';
  onClose = noop;

  use() {
    this.getVideoUrlRequest = useRequest(async () => await Service.getVideoAsync(), { manual: true, throwOnError: true });
    useMount(() => {
      this.showStatus = true;
    });
  }
}

export default VideoModalStore;
